import { Repeat2 } from 'lucide-react';
import Link from 'next/link';
import type React from 'react';
import type { HTMLAttributes } from 'react';
import { UserPreview } from '@/components/shared/previews/UserPreview';
import { buildUserProfileRoute } from '@/lib/routes/app';
import type { TweetAuthor } from '@/types/tweet';
import { TweetAvatar } from './TweetAvatar';

interface RetweetWrapperProperties extends HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  compact?: boolean;
  retweeter: TweetAuthor;
}

export function RetweetWrapper({ retweeter, children, compact = false, ...properties }: RetweetWrapperProperties) {
  return (
    <article aria-label={`Retweet by ${retweeter.name}`} {...properties}>
      {/* Retweet indicator */}
      <div
        className={`flex items-center gap-2 px-3 pt-2 pb-1 text-muted-foreground ${
          compact ? 'text-xs' : 'text-xs sm:text-sm sm:px-4'
        }`}
      >
        <div className="flex-shrink-0">
          <TweetAvatar author={retweeter} size="xxs" />
        </div>
        <div className="flex items-center gap-1.5">
          <Repeat2 className={compact ? 'h-3 w-3' : 'h-3 w-3 sm:h-3.5 sm:w-3.5'} aria-hidden="true" />
          <UserPreview username={retweeter.username}>
            <Link
              href={buildUserProfileRoute(retweeter.username)}
              className="flex items-center gap-1.5 hover:underline decoration-gray-400"
            >
              <span className="font-medium text-muted-foreground">{retweeter.name}</span>
              <span className="text-muted-foreground dark:text-muted-foreground"> reposted</span>
            </Link>
          </UserPreview>
        </div>
      </div>
      {/* Original tweet content */}
      {children}
    </article>
  );
}
